import { useState, useEffect, useRef, useContext } from 'react';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
// import PageInput from '../sub-components/PageInput';
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import CompanyProfileRow from '../sub-components/CompanyProfileRow';
import PageContext from '../sub-components/PageContext';
import ViewSubCompaniesModal from '../sub-components/ViewCompaniesModal';
import standardSearch from '../functions/standardSearch';
import applyFilters from '../functions/applyFilters';
import { HttpContext } from '../../api-services/HttpService';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import PageInputRedux from '../sub-components/PageInputReduxTooltopCopy.jsx';
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import PageDropdownRedux from '../sub-components/PageDropdownReduxCopy.jsx'; 
import standardFilter from '../functions/standardFilter.js'; 
import PageDropdownReduxWithIdObj from '../sub-components/PageDropdownReduxWithIdObj.jsx'; 
import isNullOrUndefined from '../functions/isNullOrUndefined.js'; 
import { features } from '../../config/clientResolver';

const CompanyProfilePage = () =>{
    // initialize http context 
    const {
        GET, 
    } = useContext(HttpContext);
    // initialize redux persisent state for search 
    const companyProfileSearch = useSelector((state) => state.companyProfileSearch);
    const companyTypeFilter1 = useSelector((state) => state.companyTypeFilter1); 
    const rebatePortfolio1 = useSelector((state) => state.rebatePortfolio1); 
    const spendMappingType = useSelector((state) => state.spendMappingType1); 
    const dispatch = useDispatch();
    const { 
        setCompanyProfileSearch, 
        setCompanyTypeFilter1, 
        setRebatePortfolio1, 
        setSpendMappingType1: setSpendMappingType
    } = bindActionCreators(actionCreators, dispatch);
    // initialize state for table
    const [showDataList, setShowDataList] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [tableHeader, setTableHeader] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    // initialize state for filter lists
    const [allObj, setAllObj] = useState({id: 'All', label: 'All' }); 
    const [companyTypeList, setCompanyTypeList] = useState([allObj]); 
    const [rebatePortfolioList, setRebatePortfolioList] = useState(['All']); 
    const [spendMappingList, setSpendMappingList] = useState([allObj]); 
    const [showSpendMappingList, setShowSpendMappingList] = useState([allObj]); 
    // initialize state for company numbers modal 
    const [viewModal, setViewModal] = useState(false);
    const [viewCompany, setViewCompany] = useState({});
    const [enableReset, setEnableReset] = useState(false);
    // initialize ref for initial render
    const initialRender = useRef(true);

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader,stickyFirstColumnEnabled,index,selectableRows) =>{
        return(
            <>
                <CompanyProfileRow row={row} count={count} tableHeader={tableHeader} selectableRows={selectableRows}/>
            </>
        ); 
    }  

    //get and set all info from database to render
    const getCompanyData = () => {
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise ((resolve, reject) => {
            GET('/data/masterCompanyData', {}).then(res => {
                console.log(res);
                // set table state
                setShowDataList(showDataList => showDataList = res['data']['MasterCompanyData']);
                setDataList(dataList => dataList = res['data']['MasterCompanyData']);
                setTableHeader(tableHeader => tableHeader = res['data']['CompanyProfilePageCols']);
                // set filter state 
                setCompanyTypeList([allObj, ...res.data.CompanyTypeList]); 
                setRebatePortfolioList(rebatePortfolioList => rebatePortfolioList = ['All', ...res['data']['PortfolioList']]); 
                if (res.data.SpendMappingList) {
                    setSpendMappingList([...res.data.SpendMappingList]); 
                    setShowSpendMappingList([...res.data.SpendMappingList]); 
                }
                // stop showing spinner
                setShowSpinner(showSpinner => showSpinner = false);
                // resolve response
                resolve(res);
            }).catch(err => {
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        });
    }

    // useEffect that runs on initial render
    useEffect(()=>{
        // function to do initial get and set of 
        getCompanyData().then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });
    }, []);

     // useEffect to run list of search/filter functions on table data
     useEffect(() => { 
        // do not run on initial render
        if (!initialRender.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardSearch, value: companyProfileSearch, flag: 0, cols: ['mastercompanyname', 'mastercompanyid', 'primaryccrm']}, 
                {function: standardFilter, value: companyTypeFilter1['label'], flag: 1, cols: ['companytypedescription']}, 
                {function: standardFilter, value: rebatePortfolio1, flag: 1, cols: ['incentivetype']}, 
                {function: standardFilter, value: spendMappingType['label'], flag: 1, cols: ['mappingdescription']}
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(dataList, functionList);
            // update showDataList
            setShowDataList(showDataList => showDataList = filteredList);
        }
        else{
            initialRender.current = false;
        }
        
    }, [dataList, companyProfileSearch, companyTypeFilter1, rebatePortfolio1, spendMappingType]);

    // for filtering spendMappingType on companyTypeId change
    useEffect(() => {
        // filter spend mapping list of there is a company type id selected
        if (!isNullOrUndefined(companyTypeFilter1) && !isNullOrUndefined(companyTypeFilter1.id)) {
            const functionList = [
                {function: standardFilter, value: companyTypeFilter1.id, flag: 1, cols: ['companytypeid']}
            ]; 
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(spendMappingList, functionList);
            // update list 
            setShowSpendMappingList([allObj, ...filteredList]); 
            // if companyTypeFilter is not in list change it to all
            if (!filteredList.includes(spendMappingType)) {
                setSpendMappingType(allObj);  
            }
        }
    }, [spendMappingList, companyTypeFilter1]); 

    // object to pass variables to context 
    const settings = {
        viewModal, 
        setViewModal, 
        viewCompany, 
        setViewCompany, 
    };

    //reset functionality 
    const resetToDefault = () => {
        setCompanyProfileSearch('');
        setCompanyTypeFilter1(companyTypeList[0]); 
        setRebatePortfolio1(rebatePortfolioList[0]); 
    }

    const enableResetAll = () => {
        if( companyProfileSearch !== '' || companyTypeFilter1 !== companyTypeList[0] || rebatePortfolio1 !== rebatePortfolioList[0]
        ){
            return true;
        }
        return false;
    }
 
    useEffect(() => {
        if(enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [companyProfileSearch, companyTypeFilter1, rebatePortfolio1]); 

    return(
        <div class='summary-page'>
            {/* wrap children so they can access variables in PageContext */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* modal for viewing sub companies. Default is hidden state */}
                <ViewSubCompaniesModal />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        {/* label for search column dropdown and search bar */}
                        <div className="mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between flex-wrap p-3'>
                                <div className='d-flex'>
                                    <div className='align-self-center'>Search By</div>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/CompanyProfilePage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={process.env.REACT_APP_MASTER_COMPANY_ID_TAG}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/CompanyProfilePage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/CompanyProfilePage' ? '#fff' : '#001317'}
                                                width={'120px'}
                                            />
                                        </Link>
                                    </div>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/SubCompanySearchPage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Company"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/SubCompanySearchPage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/SubCompanySearchPage' ? '#fff' : '#001317'}
                                                width={'120px'}
                                            />
                                        </Link>
                                    </div>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/ConsortiumSearchPage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Consortium"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/ConsortiumSearchPage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/ConsortiumSearchPage' ? '#fff' : '#001317'}
                                                width={'120px'}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <hr style={{ margin: 0 }}/>
                            <div className='d-flex p-3'>
                                <div className= "pe-3">
                                    <PageDropdownReduxWithIdObj tag='Company Type' obj={companyTypeFilter1} setObj={setCompanyTypeFilter1} list={companyTypeList} />
                                </div>   
                                <div className= "pe-3">
                                    <PageDropdownRedux tag='Portfolio' value={rebatePortfolio1} setValue={setRebatePortfolio1} list={rebatePortfolioList} />
                                </div>   
                                {features.feeCategorySpendMapping && (
                                    <div className='pe-3'>
                                        <PageDropdownReduxWithIdObj tag='SpendMapping' obj={spendMappingType} setObj={setSpendMappingType} list={showSpendMappingList} />
                                    </div>
                                )}
                                <div className='pe-2 align-self-center'>
                                    Search Company by
                                </div>
                                <div className= "pe-3">
                                    <PageInputRedux tag='' value={companyProfileSearch} setValue={setCompanyProfileSearch} width='100%'/>
                                </div>
                                <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableReset ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableReset ? resetToDefault(): null}>
                                        Reset All
                                </div>
                            </div>

                        </div>
                        {/* table to display company data with links for drilldown */}
                        <div className="flex-grow-1" style={{ borderRadius: '12px', background: '#fff' }}>
                            <OrderedDataTable RowComponent={RowComponent} tableHeader={tableHeader} dataList={showDataList} showSpinner={showSpinner} numToPage={50} skeletonHeight='28vh'
                                sortingEnabled={true} stickyFirstColumnEnabled={false} selectableRows/>
                        </div>
                    </div>
                </div>
        
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div>
    );
} 

export default CompanyProfilePage;